module.exports = __webpack_public_path__ + "img/vitara-2023.6cec5e8a.png";